import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=ca40f36e&scoped=true&"
import script from "./Instructor.vue?vue&type=script&lang=js&"
export * from "./Instructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca40f36e",
  null
  
)

export default component.exports